import { render, staticRenderFns } from "./pep-modal.vue?vue&type=template&id=39573172&"
import script from "./pep-modal.vue?vue&type=script&lang=ts&"
export * from "./pep-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports